import { Device, getLocationMapsURL } from '@mi-front/core';
import { StatusBadge, theme } from '@mi-front/ui';
import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
export function DeviceStatus(p: { device: Device }) {
  return (
    <StatusBadge
      size="small"
      style={{ width: '6rem' }}
      status={p.device.isOnline}
      onText="Online"
      offText="Offline"
    />
  );
}

const GMapsLink = styled.a`
  font-size: 0.85rem;
  line-height: 1.5rem;
  color: ${theme.gray600};
`;

export function DeviceLocation(p: { device: Device }) {
  const { location, coords } = p.device;

  const map = (
    <GMapsLink target="_blank" href={getLocationMapsURL(coords.lat, coords.lng)}>
      <FormattedMessage
        id="streamerBox.viewScreen.clickLocation"
        defaultMessage="Mostrar ubicación en el mapa"
      />
    </GMapsLink>
  );

  return (
    <>
      <div>
        {location} <br />
        <FormattedMessage
          id="streamerBox.device.coords"
          defaultMessage="(Lat. {lat}, Long. {lng})"
          values={{ lat: coords.lat, lng: coords.lng }}
        />
      </div>
      {map}
    </>
  );
}
